/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { appControllerHealthCheck } from '../fn/app/app-controller-health-check';
import { AppControllerHealthCheck$Params } from '../fn/app/app-controller-health-check';

@Injectable()
export class ProductsServiceAppService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appControllerHealthCheck()` */
  static readonly AppControllerHealthCheckPath = '/api/v1/products/health';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerHealthCheck()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHealthCheck$Response(
    params?: AppControllerHealthCheck$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const obs = appControllerHealthCheck(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerHealthCheck$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerHealthCheck(
    params?: AppControllerHealthCheck$Params,
    context?: HttpContext
  ): Observable<void> {
    const resp = this.appControllerHealthCheck$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
